import { render, staticRenderFns } from "./EditorShell.vue?vue&type=template&id=4441761d&"
import script from "./EditorShell.vue?vue&type=script&lang=js&"
export * from "./EditorShell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports